import { render, staticRenderFns } from "./EditorSettingsEdit.vue?vue&type=template&id=f8878142&scoped=true"
import script from "./EditorSettingsEdit.vue?vue&type=script&lang=ts"
export * from "./EditorSettingsEdit.vue?vue&type=script&lang=ts"
import style0 from "./EditorSettingsEdit.vue?vue&type=style&index=0&id=f8878142&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8878142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8878142')) {
      api.createRecord('f8878142', component.options)
    } else {
      api.reload('f8878142', component.options)
    }
    module.hot.accept("./EditorSettingsEdit.vue?vue&type=template&id=f8878142&scoped=true", function () {
      api.rerender('f8878142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/EditorSettingsEdit.vue"
export default component.exports